import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import MarketingLayout from '../layouts/MarketingLayout';

export default function AceptarContador() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';

  const [loading, setLoading] = useState(true);
  const [invite, setInvite] = useState(null);
  const [error, setError] = useState('');
  const [form, setForm] = useState({ name: '', password: '', confirm: '' });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!token) {
      setError('Link de invitación inválido.');
      setLoading(false);
      return;
    }
    fetch(`/api/contador/invite/${encodeURIComponent(token)}`)
      .then(async (res) => {
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || 'Invitación inválida');
        setInvite(data);
        setForm((p) => ({ ...p, name: data.name || '' }));
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) {
      setError('Las contraseñas no coinciden.');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      const res = await fetch('/api/contador/invite/accept', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          token,
          name: form.name,
          password: form.password,
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Error al crear cuenta');
      setDone(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <MarketingLayout>
      <div className="min-h-[70vh] flex items-center justify-center px-4 py-16">
        <div className="w-full max-w-md rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
          <h1 className="text-xl font-bold text-gray-900 mb-1">Acceso contador</h1>
          <p className="text-sm text-gray-600 mb-4">
            Solo lectura: ventas, egresos, impagas y pack contable.
          </p>

          {loading && <p className="text-sm text-gray-500">Validando invitación…</p>}
          {error && !loading && (
            <p className="text-sm text-red-600 mb-4">{error}</p>
          )}

          {done && (
            <p className="text-sm text-green-700">
              Cuenta creada. Redirigiendo al login…
            </p>
          )}

          {!loading && invite && !done && (
            <>
              <p className="text-sm text-gray-700 mb-4">
                <strong>{invite.ownerName}</strong> te invita a ver <strong>{invite.company}</strong>.
                <br />
                Email: <strong>{invite.email}</strong>
              </p>
              <form onSubmit={handleSubmit} className="space-y-3">
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Tu nombre</label>
                  <input
                    type="text"
                    value={form.name}
                    onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
                    className="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm"
                    required
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Contraseña</label>
                  <input
                    type="password"
                    value={form.password}
                    onChange={(e) => setForm((p) => ({ ...p, password: e.target.value }))}
                    className="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm"
                    minLength={6}
                    required
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Confirmar contraseña</label>
                  <input
                    type="password"
                    value={form.confirm}
                    onChange={(e) => setForm((p) => ({ ...p, confirm: e.target.value }))}
                    className="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm"
                    minLength={6}
                    required
                  />
                </div>
                <button
                  type="submit"
                  disabled={submitting}
                  className="w-full py-2.5 rounded-xl bg-[#1F80FF] text-white text-sm font-semibold hover:bg-[#004AAD] disabled:opacity-50"
                >
                  {submitting ? 'Creando cuenta…' : 'Crear acceso Lector'}
                </button>
              </form>
            </>
          )}

          {!loading && !invite && !done && (
            <Link to="/login" className="text-sm text-[#1F80FF] hover:underline">
              Ir al login
            </Link>
          )}
        </div>
      </div>
    </MarketingLayout>
  );
}
